// extracted by mini-css-extract-plugin
module.exports = {"banner":"_6f2b949","messageContainer":"_79ee6d5","title":"_c81c5c1","subTitle":"_17dfcb9","logo":"_2046e28"};